<div
  class="bg-gradient-main min-vh-100 d-flex flex-row align-items-center"
  data-theme="dark"
>
  <c-container>
    <c-row class="justify-content-center">
      <c-col md="6" lg="5">
        <c-card class="auth-right">
          <c-card-body class="p-4">
            <h1 class="auth-title mb-1">Forgot Password</h1>
            <p class="muted mb-4">Reset your password in three easy steps</p>

            @if (errorMsg) {
            <c-alert color="danger" class="modern-alert mb-3">
              {{ errorMsg }}
            </c-alert>
            } @if (infoMsg) {
            <c-alert color="info" class="modern-alert mb-3">
              {{ infoMsg }}
            </c-alert>
            } @if (step === 1) {
            <c-input-group class="mb-3 auth-input">
              <span cInputGroupText>
                <svg cIcon name="cilEnvelopeClosed"></svg>
              </span>
              <input
                [(ngModel)]="email"
                name="email"
                cFormControl
                placeholder="Enter your email"
              />
            </c-input-group>
            <button
              (click)="initiate()"
              cButton
              class="btn--primary-gradient w-100"
            >
              Reset Password
            </button>
            } @if (step === 2) {
            <c-input-group class="mb-3 auth-input">
              <span cInputGroupText>
                <svg cIcon name="cilKey"></svg>
              </span>
              <input
                [(ngModel)]="otp"
                name="otp"
                cFormControl
                placeholder="Enter OTP"
              />
            </c-input-group>
            @if (remainingTime > 0) {
            <p class="text-center mb-3" style="color: #fff">
              Time left:
              <strong style="color: #fff">{{ remainingTime }}s</strong>
            </p>
            } @if (remainingTime === 0) {
            <p class="text-center mb-3 text-danger">
              OTP expired. Please resend.
            </p>
            }
            <div class="d-flex gap-2">
              <button
                (click)="verify()"
                cButton
                class="btn--primary-gradient w-100"
                [disabled]="remainingTime === 0"
              >
                Verify OTP
              </button>
              <button (click)="resend()" cButton color="link" class="w-100">
                Resend
              </button>
            </div>
            } @if (step === 3) {
            <c-input-group class="mb-3 auth-input">
              <span cInputGroupText>
                <svg cIcon name="cilLockLocked"></svg>
              </span>
              <input
                [(ngModel)]="newPassword"
                type="password"
                name="newPassword"
                cFormControl
                placeholder="New password"
              />
            </c-input-group>
            <!-- Confirm password -->
            <c-input-group class="mb-3 auth-input">
              <span cInputGroupText>
                <svg cIcon name="cilLockLocked"></svg>
              </span>
              <input
                [(ngModel)]="confirmPassword"
                type="password"
                name="confirmPassword"
                cFormControl
                placeholder="Confirm new password"
              />
            </c-input-group>
            @if (confirmPassword && newPassword !== confirmPassword) {
            <p class="text-danger small mb-2">Passwords do not match.</p>
            }
            <button
              (click)="complete()"
              cButton
              class="btn--primary-gradient w-100"
              [disabled]="
                !newPassword ||
                !confirmPassword ||
                newPassword !== confirmPassword
              "
            >
              Reset Password
            </button>
            } @if (step === 4) {
            <c-alert color="success" class="modern-alert">
              Password reset successful! You can now
              <a routerLink="/login" class="fw-bold">login</a>.
            </c-alert>
            }

            <div class="text-center mt-3">
              <a routerLink="/login" class="link-quiet">Back to login</a>
            </div>
          </c-card-body>
        </c-card>
      </c-col>
    </c-row>
  </c-container>
</div>
